module.exports = __webpack_public_path__ + "fonts/DINPro-Bold.c44c23f2.ttf";